import ACTIONS from "../constants/actions";

const {
  POST_LOGIN_REQUEST,
  POST_LOGIN_REQUEST_SUCCESS,
  POST_LOGIN_REQUEST_FAIL,
  PASSWORD_IS_EXPIRED,
  LOGIN_WITH_KEYCLOAK,
  LOGIN_WITH_KEYCLOAK_SUCCESS,
  LOGIN_WITH_KEYCLOAK_FAIL,
} = ACTIONS;

const initialState = {
  isLoadingLogin: false,
  isPasswordExpired: false,
  isLoadingChangeExpiredPassword: false,
  isChangeExpiredPasswordSuccess: false,
  keycloakLoading: false,
  errorLoginKeycloak: null,
};

const loginPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_LOGIN_REQUEST:
      return {
        ...state,
        isLoadingLogin: true,
        isPasswordExpired: false,
      };
    case POST_LOGIN_REQUEST_SUCCESS:
      return {
        ...state,
        isLoadingLogin: false,
      };
    case POST_LOGIN_REQUEST_FAIL:
      return {
        ...state,
        isLoadingLogin: false,
      };
    case PASSWORD_IS_EXPIRED:
      return {
        ...state,
        isPasswordExpired: true,
        username: action.payload,
      };
    case LOGIN_WITH_KEYCLOAK:
      return {
        ...state,
        keycloakLoading: true,
        errorLoginKeycloak: null,
      };
    case LOGIN_WITH_KEYCLOAK_SUCCESS:
      return {
        ...state,
        keycloakLoading: false,
      };
    case LOGIN_WITH_KEYCLOAK_FAIL:
      return {
        ...state,
        keycloakLoading: false,
        errorLoginKeycloak: {
          status: action.payload ? action.payload.status : 500,
          error: "Login with keycloak fail!",
        },
      };
    default:
      return state;
  }
};
export default loginPageReducer;
